import MainLayout from './MainLayout';

export default MainLayout;



// WEBPACK FOOTER //
// ./src/containers/layouts/MainLayout/index.js